// test368
(368 && 0);
